'use strict';

const { fetchHomepageRecommendedProducts } = require('./adformBidsRequest');
const adformConstants = require('./adformConstants');
const HOMEPAGE_RECOMMENDED_PRODUCTS_ADS_POSITIONS = adformConstants.HOMEPAGE_RECOMMENDED_PRODUCTS_ADS_POSITIONS;
const adformElementEvents = require('./adformElementEvents');

const initPopOver = require('../../../../../../app_progamers_core/cartridge/client/default/js/components/initPopOver');
const { productTileTrackingInViewport } = require('../../../../../../app_progamers_core/cartridge/client/default/js/components/datalayer');

/**
 * Fetch products from our BE based on adform bids (product_ids...).
 * On success, generates and renders "featured block" with these products.
 * @param {Object[]} bids - adform bids
 * @param {Element} slider - slider where we inject products
 */
function ajaxFetchProducts(bids, slider) {
    let ajaxUrl = window.ajaxSearchAdxProductTilesByPidUrl;
    const swiperWrapper = slider?.querySelector('.swiper-wrapper');
    if (!ajaxUrl || !slider || !swiperWrapper) {
        return;
    }

    const productIdsPerBid = bids.map(
        bid => bid.descriptionAsset.product_ids.map(
            pid => pid.replaceAll('"', '')
        )
    );

    fetch(`${ajaxUrl}?productIdsPerBidJson=${JSON.stringify(productIdsPerBid)}`)
        .then((response) => {
            if (response.ok) {
                return response.text();
            }

            return false;
        })
        .then((html) => {
            if (!html) {
                return;
            }

            const parser = new DOMParser();
            const responseDom = parser.parseFromString(html, 'text/html');
            const responseTileWrappers = responseDom.querySelectorAll('.js-adform-product-wrapper');

            if (!responseTileWrappers.length) {
                return;
            }

            const sliderSlides = slider.querySelectorAll('.swiper-slide');
            if (!sliderSlides.length) {
                return;
            }

            const sliderSwiperInstance = slider.swiper;

            let sliderActiveSlideIndexBeforeInsert = null;
            if (sliderSwiperInstance) {
                sliderActiveSlideIndexBeforeInsert = sliderSwiperInstance.activeIndex;
            }

            responseTileWrappers.forEach((responseTileWrapper, index) => {
                const tilePositionIndex1Notation = HOMEPAGE_RECOMMENDED_PRODUCTS_ADS_POSITIONS[index];
                if (!(tilePositionIndex1Notation >= 0)
                    || tilePositionIndex1Notation > sliderSlides.length
                ) {
                    return;
                }

                const bidIndex = responseTileWrapper.getAttribute('data-bidIndex');
                const pdpURL = responseTileWrapper.getAttribute('data-pdpURL');
                const bid = bids[bidIndex];

                if (!bid
                    || !pdpURL
                ) {
                    return;
                }

                const newSlide = document.createElement('div');
                newSlide.classList.add('swiper-slide');
                newSlide.classList.add('apply-slide-cls-fix');
                newSlide.setAttribute('data-pdpURL', pdpURL);
                newSlide.innerHTML = responseTileWrapper.innerHTML;

                if (sliderSwiperInstance) {
                    sliderSwiperInstance.addSlide(tilePositionIndex1Notation - 1, newSlide);
                } else {
                    const tilePosition = tilePositionIndex1Notation - 1 - index;
                    const siblingSlide = sliderSlides[tilePosition];
                    if (!siblingSlide) {
                        return;
                    }
                    siblingSlide.parentNode.insertBefore(newSlide, siblingSlide);
                }

                const newSlideProduct = newSlide.querySelector('.product');
                if (newSlideProduct) {
                    document.body.dispatchEvent(new CustomEvent('product:tileRendered', { detail: newSlide, bubbles: true }));
                    adformElementEvents.initSponsoredProductAdInViewportObserver(newSlideProduct, bid);
                    adformElementEvents.initSponsoredProductAdClickEvent(newSlideProduct, bid, pdpURL);
                }
            });

            if (sliderSwiperInstance) {
                let isSliderActiveSlideChangedByInsert = sliderSwiperInstance.activeIndex !== sliderActiveSlideIndexBeforeInsert;
                if (sliderActiveSlideIndexBeforeInsert === 0 && isSliderActiveSlideChangedByInsert) {
                    sliderSwiperInstance.slideTo(sliderActiveSlideIndexBeforeInsert);
                }
                sliderSwiperInstance.update();
            }

            initPopOver();

            slider.querySelectorAll('.swiper-slide').forEach((slide, index) => {
                slide.setAttribute('data-tracking-position', `${index + 1}`.toString());
            });

            // if fired, we init viewport logic again (to fire again when user notices new adform tiles)
            const hasViewItemListEventAlreadyFired = !!(slider.querySelector('[data-tracking-product-tile-processed="true"]'));
            if (hasViewItemListEventAlreadyFired) {
                productTileTrackingInViewport(slider);
            }
        });
}

/**
 * Init events that make adform request to get data needed for products.
 */
function initMakeRequestEvents() {
    document.addEventListener('DOMContentLoaded', () => {
        const tagId = adformConstants.HOMEPAGE_RECOMMENDED_PRODUCTS_TAG_ID;
        const slider = document.querySelector('.js-homepage-recommendation-slider');

        if (!tagId || !slider) {
            return;
        }

        fetchHomepageRecommendedProducts(slider);
    }, { once: true }); // context: cookiebot may fire event again when partially accepted (since cookiebot not 1st script in head)
}

/**
 * Init events that wait for adform response to get processed:
 * - case bids exist => inject products to slider (search based on adform response)
 * - case no bids => nothing happens
 */
function initResponseHandlingEvents() {
    document.addEventListener(adformConstants.HOMEPAGE_RECOMMENDED_PRODUCTS_BIDS_READY_CUSTOM_EVENT_NAME, function (e) {
        const bids = e.detail?.bids;
        const additionalEventData = e.detail?.additionalEventData;
        const slider = additionalEventData?.slider;
        if (!slider || !bids.length) {
            return;
        }

        ajaxFetchProducts(bids, slider);
    });

    document.addEventListener(adformConstants.HOMEPAGE_RECOMMENDED_PRODUCTS_NO_BIDS_CUSTOM_EVENT_NAME, function () {});
}

/**
 * Init adform fetch request and handling response (bids or no bids).
 *
 * Important:
 * initResponseHandlingEvents() must be called before initMakeRequestEvents()
 * => otherwise request could dispatch event (e.g. early return "no-bids" event when request not valid)
 *    that can't be processed (response handler event not initialized yet)
 */
function initRequestLifecycleEvents() {
    initResponseHandlingEvents();
    initMakeRequestEvents();
}

module.exports = {
    init: function () {
        if (!window.shouldFetchAdformHomepageRecommendedProducts
            || !Array.isArray(HOMEPAGE_RECOMMENDED_PRODUCTS_ADS_POSITIONS)
            || HOMEPAGE_RECOMMENDED_PRODUCTS_ADS_POSITIONS.length === 0
        ) {
            return;
        }

        initRequestLifecycleEvents();
    }
};
